<template>
  <b-container fluid>
    <b-row>
      <b-col lg="4">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">
              <b>{{ detail.username }}</b>
            </h4>
          </template>
          <template v-slot:body>
            <div class="d-flex justify-content-center">
              <b-badge class="border border-dark text-dark" variant="none" v-show="detail.active === '1'">Đang hoạt động</b-badge>
              <b-badge class="border" variant="danger" v-show="detail.active === '0'">Đang khóa</b-badge>
            </div>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Thông tin cá nhân</h4>
          </template>
          <template v-slot:body>
            <b-list-group flush>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <b-badge variant="primary" pill>Tên tài khoản</b-badge>
                {{detail.username}}
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <b-badge variant="primary" pill>Họ tên</b-badge>
                {{detail.fullname}}
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-center align-items-center">
                <b-button :variant="'danger'" @click="toggleUser" v-show="detail.active === '1'" :disabled="serverRequesting">
                  <i class="las la-user-lock"/>
                  Khóa tài khoản</b-button>
                <b-button :variant="'primary'" @click="toggleUser" v-show="detail.active === '0'" :disabled="serverRequesting">
                  <i class="las la-unlock"/>
                  Mở khóa tài khoản</b-button>
              </b-list-group-item>
            </b-list-group>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="8">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Đổi mật khẩu</h4>
          </template>
          <template v-slot:body>
            <li>Mật khẩu phải có từ <b>8 đến 20 kí tự</b></li>
            <li>Mật khẩu phải có ít nhất <b>1 kí tự thường</b></li>
            <li>Mật khẩu phải có ít nhất <b>1 kí tự Hoa</b></li>
            <li>Mật khẩu phải có ít nhất <b>1 kí tự đặc biệt</b></li>
            <hr>
            <ValidationObserver v-slot="{ handleSubmit, invalid }">
              <b-form @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider rules="required" v-slot="{ errors }" name="password">
                  <b-form-group label="Mật khẩu mới">
                    <b-form-input type="text" v-model="new_password"/>
                    <span class="text-warning">{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>
                <b-button :disabled="invalid" type="submit" variant="primary" class="mb-3"><i class="las la-user-edit"/> Xác nhận</b-button>
              </b-form>
            </ValidationObserver>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<style>
.iq-card-header{
  display: flex !important;
  justify-content: center !important;
}
</style>
<script>
import { findash } from '../../config/pluginInit'
import { localize } from 'vee-validate'
import api from '../../store/api'
import { mapGetters } from 'vuex'

export default {
  name: 'UserDetail',
  created () {
    localize('en', {
      fields: {
        'password': { required: 'Mật khẩu không được để trống' }
      }
    })
  },
  async mounted () {
    findash.index()
    await this.loadDetail()
  },
  data () {
    return {
      new_password: null,
      detail: {}
    }
  },
  computed: {
    fullname () {
      return `${this.detail.first_name} ${this.detail.last_name}`
    },
    ...mapGetters({
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    async loadDetail () {
      const idRouter = this.$route.params.code
      const response = await api.sub_account.detail(idRouter)

      this.detail = response
    },
    async toggleUser () {
      let response

      if (this.detail.active === '1') {
        response = await api.sub_account.lock(this.detail.id)
      } else {
        response = await api.sub_account.active(this.detail.id)
      }

      this.$swal({
        icon: 'success',
        title: response.message
      })

      await this.loadDetail()
    },
    async onSubmit () {
      api.sub_account.change_password(this.detail.id, this.new_password).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Đổi mật khẩu thành công'
        })
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    }
  }
}
</script>
